import styled from "styled-components/macro";

import { motion } from "framer-motion";

export default function Placeholder({ title, text, icon }) {
  return (
    <Wrapper
      layout
      initial={{ opacity: 0, scale: 0.75 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{
        opacity: 0,
        scale: 0.75,
        maxHeight: 0,
        transition: { type: "tween" },
      }}
    >
      {icon && <Icon className={icon} />}
      {title && <Title>{title}</Title>}
      {text && <Text>{text}</Text>}
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 40px;
  text-align: center;
`;

const Icon = styled.div`
  display: block;
  font-size: 56px;
  color: #828c8d;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 400;
  .user_profile & {
    font-family: Merriweather;
  }
`;

const Text = styled.div`
  font-size: 14px;
  color: #828c8d;
  .user_profile & {
    font-family: Raleway;
  }
`;
